export enum FilterType {
  All = 'all',
  Active = 'active',
  Completed = 'completed',
}
